import { gql } from '@apollo/client';

export const GET_HUB_LIST = gql`
    query GetHubList {
        hubList: getHubList {
            id
            name
            sortingCode
            siteType
        }
    }
`;

export interface HubType {
    id: string;
    name: string;
    sortingCode?: string;
    siteType: number;
}

export interface GetHubListResponse {
    hubList: HubType[];
} 